import { useMemo } from 'react';
import { AssistantEditDialogProps } from '../components/app/AssistantEditDialog';
import { AdminWorkspaceProps } from '../components/app/AdminWorkspace';

type Params = {
  adminOpen: boolean;
  onClose: () => void;
  assistantEditDialog: AssistantEditDialogProps;
};

export function useAdminWorkspace({
  adminOpen,
  onClose,
  assistantEditDialog,
}: Params): AdminWorkspaceProps {
  const adminDrawerProps = useMemo(() => ({
    adminOpen,
    onClose,
  }), [adminOpen, onClose]);

  return {
    adminOpen,
    adminDrawerProps,
    assistantEditDialogProps: assistantEditDialog,
  };
}
